module.exports = __webpack_public_path__ + "static/img/问诊.735d8f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/apphome/问诊.png
// module id = eodx
// module chunks = 1